import Seo from '../components/Seo';

export default function Prices() {
  const whatsappBookingLink = "https://wa.me/447449975074?text=Hello%2C%20I%20am%20interested%20in%20booking%20driving%20lessons%20with%20Bezy%20Driving%20School.%20Could%20you%20please%20provide%20information%20about%20availability%20and%20next%20steps%3F";

  const plans = [
    {
      name: "By The Hour",
      price: "£45",
      period: "/hour",
      description: "Flexible pay-as-you-go lessons",
      features: [],
      highlighted: false
    },
    {
      name: "Bulk Buy Deal 1 (Best Value)",
      price: "£800",
      period: "/20 hours",
      description: "Save £100 compared to hourly",
      features: [
        "20 hours of lessons",
        "Only £40/hour (Save ~11%)",
        "Valid for 6 months"
      ],
      highlighted: true
    },
    {
      name: "Bulk Buy Deal 2",
      price: "£410",
      period: "/10 hours",
      description: "Save £90 compared to hourly",
      features: [
        "10 hours of lessons",
        "Only £41/hour (Save ~9%)",
        "Valid for 6 months"
      ],
      highlighted: false
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <Seo
        title="Driving Lesson Prices | Erith, Belvedere & Sidcup Test Centres | Bezy Driving School"
        description="Flexible driving lesson pricing with Bezy Driving School. Hourly, bundle and intensive options with a DVSA Approved Instructor. Vehicle hire available for Erith, Belvedere and Sidcup test centres."
        path="/prices"
      />
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Automatic Driving Lesson Prices
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Flexible pricing for learners in Erith, Belvedere and nearby areas. Book hourly or save more with bulk buy deals.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`rounded-lg overflow-hidden transition transform hover:scale-105 ${
                plan.highlighted
                  ? "bg-blue-600 text-white shadow-2xl scale-105"
                  : "bg-white shadow-lg"
              }`}
            >
              {/* Plan Header */}
              <div className="p-8">
                <h3 className={`text-2xl font-bold mb-2 ${
                  plan.highlighted ? "text-white" : "text-gray-900"
                }`}>
                  {plan.name}
                </h3>
                <p className={`${plan.highlighted ? "text-blue-100" : "text-gray-600"} mb-4`}>
                  {plan.description}
                </p>
                <div className="mb-6">
                  <span className="text-4xl font-bold">{plan.price}</span>
                  <span className={plan.highlighted ? "text-blue-100" : "text-gray-600"}>
                    {plan.period}
                  </span>
                </div>
                <a
                  href={whatsappBookingLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Book ${plan.name} on WhatsApp`}
                  className={`w-full py-3 px-4 rounded-lg font-bold transition inline-block text-center ${
                  plan.highlighted
                    ? "bg-white text-blue-600 hover:bg-gray-100"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
                >
                  Book Now
                </a>
              </div>

              {plan.features.length > 0 && (
                <>
                  {/* Features List */}
                  <div className={`px-8 py-8 ${
                    plan.highlighted ? "bg-blue-500" : "bg-gray-50"
                  }`}>
                    <p className={`font-bold mb-4 ${
                      plan.highlighted ? "text-white" : "text-gray-900"
                    }`}>
                      Includes:
                    </p>
                    <ul className="space-y-3">
                      {plan.features.map((feature, fIdx) => (
                        <li
                          key={fIdx}
                          className={`flex items-center ${
                            plan.highlighted ? "text-white" : "text-gray-600"
                          }`}
                        >
                          <span className="mr-3 text-lg">✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Lesson Duration Notice */}
        <div className="bg-gradient-to-r from-amber-50 to-orange-100 border-2 border-amber-400 rounded-2xl p-6 md:p-8 mb-8 shadow-lg">
          <div className="text-center">
            <div>
              <p className="text-sm font-extrabold uppercase tracking-[0.25em] text-amber-700 mb-2">
                Important Lesson Information
              </p>
              <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight">
                All lessons are a minimum of 2 hours unless pre-agreed.
              </h2>
              <p className="text-base md:text-lg text-gray-700 mt-2">
                Please keep this in mind when booking hourly or package lessons.
              </p>
            </div>
          </div>
        </div>

        {/* Vehicle Hire Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            📝 Vehicle Hire for Test Day
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Test Centre Fees</h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                  <span className="font-semibold">Belvedere / Erith:</span>
                  <span className="text-lg font-bold text-blue-600">£130</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                  <span className="font-semibold">Bromley / Sidcup:</span>
                  <span className="text-lg font-bold text-blue-600">£150</span>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Vehicle Hire Includes</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="mr-3 text-green-600 font-bold">✓</span>
                  <span>Pre-test warm-up drive</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-green-600 font-bold">✓</span>
                  <span>Use of car during the test</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-green-600 font-bold">✓</span>
                  <span>Drop-off back home after the test</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Motorway Lessons Banner */}
        <div className="bg-green-50 border-2 border-green-600 rounded-lg p-6 mb-4">
          <p className="text-center text-lg text-gray-800">
            <strong>🔁🚘 Refresher Lessons Available:</strong> £50 per hour (Drivers who have not driven for a long time)
          </p>
          <p className="text-center text-lg text-gray-800">
            <strong>🛣️ Motorway Lessons Available:</strong> £50 per hour
          </p>
        </div>

        {/* Special Offers Section */}
        <div className="bg-blue-50 border-2 border-blue-600 rounded-lg p-6">
          <p className="text-center text-lg text-blue-900">
            <strong>🎉 Special Offer:</strong> Get a recommendation discount when referred by existing students.
          </p>
        </div>
      </div>
    </div>
  );
}
